"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeismicHelper = void 0;
var FeatureSettingIds_1 = require("../constants/FeatureSettingIds");
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var constants_1 = require("../constants");
var locationParams_1 = require("../../util/locationParams");
var typedi_1 = require("typedi");
var SeismicHelper = /** @class */ (function () {
    function SeismicHelper() {
    }
    /**
     * @deprecated
     * Please use these services instead:
     * <br/>
     * `LaunchDarklyService.getValueAsBoolean`
     * 	<br/>
     * 	`FeatureSettingService.getFeatureSettingAsBoolean`
     * 	<br/>
     * 	`SystemOptionsService.getSystemOption`
     * 	<br/>
     * 	`ServiceAddressService.getServiceAddressByKey`
     *
     * If you do need window.appDatas as preload data, please use
     * `const preloadData = this.preloadDataService.getPreloadData();`
     * Remember that it's a underground preload mechanism and aiming for improving
     * the performance, it should only be used in bundle and seismic-common.
     * In another word, you should never use it in your feature repos.
     */
    SeismicHelper.prototype.getAppData = function () {
        return window.appDatas;
    };
    /**
     * @deprecated
     * Please use `tenantService.getTenantUniqueId()` or `tenantService.getTenantName()` instead.
     *
     * Please notice these principles as well https://seismic.atlassian.net/wiki/spaces/FEC/pages/3044446130/Tenant+Subdomain+Solution#Principles.
     */
    SeismicHelper.prototype.getTenant = function () {
        return typedi_1.Container.get('instance').getSubdomain() || window.tenant;
    };
    SeismicHelper.prototype.getRootURL = function () {
        return window.ROOT_URL || window.location.protocol + "//" + window.location.host;
    };
    /**
     * Returns true if the Seismic Web App is hosted in an iframe in an embedded application such as Salesforce
     */
    SeismicHelper.prototype.isEmbeddedApp = function () {
        var EmbeddedPage = window.EmbeddedPage;
        return !!EmbeddedPage;
    };
    /**
     * Returns client type according to 'client' or 'Client' query parameter in the url
     * 1. salesforce
     *    SFDCMiniDistributionRequester.aspx?SCTL=&spn=seismic&client=salesforce
     *   SeismicSFDCClient = {
     *      Current: {
     *           Name: 'SalesforceRequester',
     *           FullName: 'salesforce',
     *           IsSalesforce: true,
     *       }
     *   };
     * 2. DynamicsRequester
     *    SharedPredictive.aspx?Client=DynamicsRequester
     * 3. SalesforceRequester-${version}
     *    SharedPredictive.aspx?Client=SalesforceRequester-3.373&AppName=Default Embedded Application
     *
     * These 4 client types('OracleRequester','HtmlRequester','LiveShareCenter','SharePointRequester')
     * are not tested.
     */
    SeismicHelper.prototype.getClientType = function () {
        var _a, _b, _c;
        var requestParams = locationParams_1.getRequestParams();
        if (requestParams.client && window.SeismicSFDCClient) {
            return (_b = (_a = window.SeismicSFDCClient) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.FullName;
        }
        if ((_c = requestParams.client) === null || _c === void 0 ? void 0 : _c.includes(constants_1.SeismicClientType.HTML)) {
            return constants_1.SeismicClientType.HTML + '-1';
        }
        return locationParams_1.getRequestParams().client || constants_1.SeismicClientType.DOCCENTER + '-5';
    };
    /**
     * @deprecated
     * Please use `FeatureSettingService.getFeatureSettingAsBoolean` instead
     */
    SeismicHelper.prototype.getFeatureSettingState = function (featureId, originalValue) {
        var _a, _b;
        var featureSettings = (_a = this.getAppData()) === null || _a === void 0 ? void 0 : _a.application.System.SystemOptions.FeatureSettings;
        var value = ((_b = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.find(function (itm) { return itm.FeatureId === featureId; })) === null || _b === void 0 ? void 0 : _b.State) === '1';
        return value || originalValue;
    };
    /**
     * @deprecated
     * Please use `FeatureSettingService.getFeatureSettingAsBoolean` instead
     */
    SeismicHelper.prototype.getEnableNewUI = function () {
        return this.getFeatureSettingState(FeatureSettingIds_1.FeatureSettingIds.ENABLE_NEW_UI, false);
    };
    SeismicHelper = __decorate([
        CommonService_decorator_1.CommonService('SeismicHelper')
    ], SeismicHelper);
    return SeismicHelper;
}());
exports.SeismicHelper = SeismicHelper;
//# sourceMappingURL=SeismicHelper.js.map